import { Pipe, PipeTransform } from '@angular/core';

import { usuarioPerfis } from '../usuario-perfil';

@Pipe({
    name: 'usuarioPerfil'
})
export class UsuarioPerfilPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return '';
        }

        const index = usuarioPerfis.findIndex(perfil => perfil.id === value);
        if (index > -1) {
            return usuarioPerfis[index].nome;
        }
        return '';
    }
}
